import { EarthMinusIcon } from './EarthMinusIcon';

/**
 * author: Muhammet Balsoy
 * id 1C8EADAE-667F-4048-A393-B05980A7CA11
 * name earth-minus
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-minus.svg
 * tags
 * - Navigation 
 */
export const PlanetMinusIcon = EarthMinusIcon;
export default PlanetMinusIcon